// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__-fb-I","inner":"Form_inner__K68f_","range":"Form_range__3rT4w","name":"Form_name__T6rw0","actions":"Form_actions__TpL7O"};